import { Directive, ElementRef } from '@angular/core';
import { ThemeService } from 'app/private/_core/_services/theme.service';

@Directive({
    selector: '[appSvgStrokeColor]',
    standalone: false
})
export class SVGStrokeColorDirective {
	constructor(
		el: ElementRef,
		private themeService: ThemeService,
	) {
		el.nativeElement.style.stroke = this.themeService.color;
	}
}
